import { render } from "./Message.vue?vue&type=template&id=6f2aae02&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=6f2aae02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2aae02"]])

export default __exports__